// Views Main
import App from './App'

const routes = [{
  path: '/:params',
  component: App,
}];

export default routes